/* Chad's Raspberry Kitchen - crk-app.js (Horizon theme integration)
   Buy box: radio cards map to a native product form. The Subscribe card
   enables the selling_plan <select>; One-time disables it so it is not posted. */
(function () {
  "use strict";
  var box = document.querySelector("[data-buybox]");
  if (!box) return;
  var cta = box.querySelector("[data-cta]");
  var freqSelect = box.querySelector("[data-frequency]");
  var radios = box.querySelectorAll('input[name="purchase_type"]');
  var render = function () {
    var checked = box.querySelector('input[name="purchase_type"]:checked');
    var isSub = !!(checked && checked.value === "subscribe");
    if (freqSelect) freqSelect.disabled = !isSub;
    if (cta && !cta.disabled) {
      if (isSub && freqSelect) {
        var opt = freqSelect.options[freqSelect.selectedIndex];
        cta.textContent = "Subscribe Now — " + (opt.getAttribute("data-price") || "") + (opt.getAttribute("data-suffix") || "");
      } else {
        cta.textContent = "Add to Cart — " + (box.getAttribute("data-onetime-price") || "");
      }
    }
  };
  for (var i = 0; i < radios.length; i++) radios[i].addEventListener("change", render);
  if (freqSelect) freqSelect.addEventListener("change", render);
  render();
})();
